class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', event => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity({ id: this.dataset.id, quantity: 0 });
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartDrawer {
  constructor() {
    this.cartButton = document.getElementById('cart-icon-bubble');
    this.cartDrawer = document.getElementById('cart-drawer-wrapper');
    this.cartCheckoutButton = document.getElementById('cart-checkout-button');
    this.cartDrawerCloseButton = document.getElementById('close-cart-icon');
    this.defaultCartTitle = document.getElementById('cart__item-title').innerHTML;

    this.cartButton.addEventListener("click", function (e) {
      e.preventDefault();
      document.body.classList.add('drawer-open');
      this.cartDrawer.classList.remove('closed');
    }.bind(this),
    );

    this.cartDrawerCloseButton.addEventListener("click", function () {
      this.cartDrawer.classList.add('closed');
      document.body.classList.remove('drawer-open');
    }.bind(this));

    this.cartDrawer.addEventListener("click", function (e) {
      if (e.target !== this.cartDrawer) {
        return;
      }
      this.cartDrawer.classList.add('closed');
      this.updateCartTitle();
      document.body.classList.remove('drawer-open');
    }.bind(this));

  }

  updateCartPrices(parsedState) {
    document.getElementById('cart-sub-total').setAttribute('data-total', parsedState.total_price);
    document.getElementById('cart-sub-total').innerHTML = `£${(parsedState.items_subtotal_price / 100).toFixed(2)}`;
    document.getElementById('cart-total').innerHTML = ` £${(parsedState.total_price / 100).toFixed(2)}`;
  }

  updateCartTitle(text) {
    if (text === undefined) {
      text = this.defaultCartTitle;
    }
    document.getElementById('cart__item-title').innerHTML = text;
  }

  updateCartItemCount(itemCount) {
    document.getElementById('cart__item-count').innerHTML = itemCount;
  }

  updateCartPromo(parsedState) {

    if (parsedState.total_price === undefined) {
      parsedState.total_price = Number($('#cart-sub-total').data('total'));
    }
    const $cart_promo = $('#cart__promo');
    if (parsedState.total_price <= window.cart_promo.price_show_at) {
      // hide it
      $cart_promo.hide();
    } else if (parsedState.total_price >= window.cart_promo.price_show_at && parsedState.total_price <= window.cart_promo.price_needed) {
      // show not valid 
      $cart_promo.show().html(window.cart_promo.content_invalid);
    } else if (parsedState.total_price > window.cart_promo.price_needed) {
      // show valid
      $cart_promo.show().html(window.cart_promo.content_valid);
    }
  }

}

window.addEventListener('load', function () {

  // If the cart drawer doesn't exist, don't run the rest of the code
  // to safeguard console errors from missing elements //
  if (document.getElementById('cart-drawer-wrapper') === null) { return; }
  window.cartDrawer = new CartDrawer();
});

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById(
      'shopping-cart-line-item-status',
    );

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]'),
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity({
      line: event.target.dataset.index,
      quantity: event.target.value,
      name: document.activeElement.getAttribute('name'),
      id: event.target.dataset.id,
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      }
    ];
  }


  renderContents(parsedState) {
    this.classList.toggle('is-empty', parsedState.item_count === 0);

    this.getSectionsToRender().forEach(section => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });
    document.getElementById('cart-icon-bubble').click();
  }

  updateCartPromo(parsedState) {

    if (parsedState.total_price === undefined) {
      parsedState.total_price = Number($('#cart-sub-total').data('total'));
    }

    const $cart_promo = $('#cart__promo');
    if (parsedState.total_price <= window.cart_promo.price_show_at) {
      // hide it
      $cart_promo.hide();
    } else if (parsedState.total_price >= window.cart_promo.price_show_at && parsedState.total_price <= window.cart_promo.price_needed) {
      // show not valid 
      $cart_promo.show().html(window.cart_promo.content_invalid);
    } else if (parsedState.total_price > window.cart_promo.price_needed) {
      // show valid
      $cart_promo.show().html(window.cart_promo.content_valid);
    }
  }

  updateCartPagePrices(parsedState) {
    document.getElementById('cart-sub-total').innerHTML = `£${(parsedState.items_subtotal_price / 100).toFixed(2)}`;
    document.getElementById('cart-sub-total').setAttribute('data-total', parsedState.total_price);
    document.getElementById('cart-total').innerHTML = ` £${(parsedState.total_price / 100).toFixed(2)}`;
  }

  /* data {
    id: variant id
    quantity: line_item quantity
    name: name of variant to update
    line: line_item number
  } */
  updateQuantity(data) {
    const line = data.line, quantity = data.quantity, name = data.name, id = data.id;

    this.enableLoading(line);

    // We need this to be either the line number or the ID. //
    // This is due to the eco cart app making the line number change //
    // with no way to update our event handlers to reflect new line item numbers //
    const body = JSON.stringify({
      id,
      quantity,
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname,
    });


    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then(response => {
        return response.text();
      })
      .then(state => {
        const parsedState = JSON.parse(state);

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) {
          cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        }

        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });


        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          lineItem.querySelector(`[name="${name}"]`).focus();
        }

        if (document.getElementById('cart-drawer-wrapper') !== null) {
          window.cartDrawer.updateCartPrices(parsedState);
        }


        if (document.getElementById('cart__item-count') !== null) {
          document.getElementById('cart__item-count').innerHTML = parsedState.item_count;
        }


        this.updateCartPrices(parsedState);
        this.updateCartPagePrices(parsedState);
        this.updateCartPromo(parsedState);
        this.disableLoading();
      })
      .catch(state => {
        this.querySelectorAll('.loading-overlay').forEach(overlay =>
          overlay.classList.add('hidden'),
        );
        //document.getElementById('cart-errors').classList.remove('visibility-hidden');
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount && itemCount != 0) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text').innerHTML =
        window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value,
        );
    }


    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);

  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)
      .innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(overlay =>
      overlay.classList.remove('hidden'),
    );
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);
